import { Link } from 'react-router-dom';
import { DocSection, kbd } from '../../../pages/shell';
import { DocShot } from '../../DocShot';

export const toc = [
  { id: 'not-in-menu', label: 'ClipRadar isn’t in the Window menu' },
  { id: 'blank-cant-connect', label: 'The panel is blank / "can’t connect"' },
  { id: 'check-version', label: 'Check Premiere Pro is 22.3+' },
];

export default function Body() {
  return (
    <>
      <DocSection id="not-in-menu" title={'ClipRadar isn’t in the Window menu'}>
        <p>
          If ClipRadar doesn't appear in Premiere's <span style={kbd}>Window</span> menu at all, the
          panel extension (the <span style={kbd}>.ccx</span>) either isn't installed or failed to
          register — reinstalling it fixes almost every case.
        </p>
        <ol>
          <li>
            In the ClipRadar desktop app, open <span style={kbd}>Settings → Install Premiere panel</span>.
            It reveals the bundled <span style={kbd}>.ccx</span> file in File Explorer.
          </li>
          <li>Double-click the <span style={kbd}>.ccx</span> — Creative Cloud installs it directly.</li>
          <li>
            If double-click does nothing, or Premiere still doesn't list ClipRadar, install the same{' '}
            <span style={kbd}>.ccx</span> through the free{' '}
            <a href="https://zxpinstaller.com/" target="_blank" rel="noreferrer">ZXP/UXP Installer</a>: open the
            tool, drag the <span style={kbd}>.ccx</span> in, and let it install.
          </li>
        </ol>
        <DocShot
          slug="panel-wont-open"
          shot="zxp-installer"
          alt="The ZXP/UXP Installer with the ClipRadar .ccx loaded"
          caption="The ZXP/UXP Installer is the reliable fallback when a plain double-click install doesn't stick."
        />
      </DocSection>

      <DocSection id="blank-cant-connect" title={'The panel is blank / "can’t connect"'}>
        <p>
          A blank panel or a "can't connect" message means Premiere found the extension but can't
          reach the ClipRadar desktop app — the panel is just a window pointed at your local
          ClipRadar server, so that server has to be running first.
        </p>
        <ol>
          <li>Launch the ClipRadar desktop app. It's fine if it's minimized to the tray — it doesn't need to be in focus.</li>
          <li>
            In Premiere, open <span style={kbd}>Window → ClipRadar</span>, or click{' '}
            <span style={kbd}>Reconnect</span> if the panel is already open.
          </li>
        </ol>
        <DocShot
          slug="panel-wont-open"
          shot="reconnect"
          alt="The Reconnect affordance in the panel"
          panel
          caption="If you opened Premiere before ClipRadar, Reconnect finds the server without restarting Premiere."
        />
      </DocSection>

      <DocSection id="check-version" title="Check Premiere Pro is 22.3+">
        <p>
          The panel needs Premiere Pro 22.3 or newer — older builds can't host it at all, and Adobe
          won't warn you about it. Check your version from Premiere's <span style={kbd}>Help → About</span>,
          or open the Creative Cloud desktop app and update Premiere Pro if a newer version is
          available.
        </p>
        <p>
          Full compatibility details live on{' '}
          <Link to="/docs/reference/system-requirements#premiere">System requirements</Link>.
        </p>
      </DocSection>
    </>
  );
}
